window.wallpaperDownloadOnClick = function(index) {
    const value=document.getElementsByClassName('js-wallpaperSelect')[index].value;
    if(value !== 'placeholder') {
        window.open(value)
    }
}

